import { PackagesStateType } from '~shared/types/pricing/package';
import { CombinedActions } from '~shared/types/pricing/actions';
import ACTIONS from '~shared/actions';
import { PricingPackage } from '~shared/types/pricing/pricingsvc';

export default function packageReducer(state: PackagesStateType, action: CombinedActions): PackagesStateType {
  if (action.type === ACTIONS.UPDATE_PACKAGES) {
    return {
      ...state,
      allPackages: action.payload.allPackages ? action.payload.allPackages : state.allPackages,
      displayPackages: action.payload.displayPackages,
      displayPackageSet: action.payload.displayPackages.map(pkg => pkg.packageName),
    };
  }

  if (action.type === ACTIONS.UPDATE_PACKAGES_TO_DISPLAY) {
    return {
      ...state,
      packagesToDisplayState: action.payload.packagesToDisplay,
    };
  }

  if (action.type === ACTIONS.SWITCH_PACKAGES) {
    const replacementPackage = state?.allPackages.find(pkg => Number(pkg?.id) === action.payload.replacedWith);
    const newPackages = state?.displayPackages?.map(pkg =>
      Number(pkg?.id) === action.payload.packageToBeReplaced ? replacementPackage : pkg
    ) as PricingPackage[];

    const packages = newPackages ?? state.displayPackages;

    return {
      ...state,
      displayPackages: packages,
      displayPackageSet: packages.map(pkg => pkg.packageName),
    };
  }

  return state;
}
